// extracted by mini-css-extract-plugin
export default {"wrapper":"LeftSide_wrapper__b0qqP"};